export const requiredByMailaddressMessage = `メールアドレスは必須項目です`;

export const mistakeMailaddressMessage = `メールアドレスが正しくありません`;

export const moreThancharacterMessage = (from: number, to: number) =>
  `${from}文字以上${to}文字以内に変更してください`;

export const patternErrorMessage = `英字大文字、英字小文字、数字、記号のうち3種類を含めてください`;

export const matchErrorMessage = `入力されたパスワードが一致しません`;

export const requiredByUserNameMessage = `名前は必須項目です`;

export const changeUsernameCompletionMessage = `名前の変更が完了しました`;

export const changeEmailCompletionMessage = `メールアドレス(ログインID)の変更が完了しました`;

export const changePasswordCompletionMessage = `パスワードの変更が完了しました`;

export const changePasswordPolicyMessage = `※半角英大文字・小文字・数字・記号を３種以上組み合わせ(12文字以上)`;

export const dateOutOfRangeErrorMessage = `終了は開始より後の日付にしてください`;

export const timeOutOfRangeErrorMessage = `終了は開始より後の時刻にしてください`;

export const invalidTimeErrorMessage = `無効な時間です。0:00〜23:59の間で指定してください`;

// 汎用バリデーションメッセージ。新規で作成する際は基本こちらに則って作成してください。
export const required = (name: string) => `${name}は必須項目です`;
export const selected = (name: string) => `${name}を選択してください`;
export const date = (name: string) =>
  `${name}には日付(年/月/日)を入力してください`;
export const max = (name: string, max: number) =>
  `${name}は${max}文字以内で入力してください`;
export const min = (name: string, min: number) =>
  `${name}は${min}文字以内で入力してください`;
export const halfWidth = (name: string) =>
  `${name}は半角文字を入力してください`;
export const halfWidthNumber = (name: string) =>
  `${name}は半角数字を入力してください`;
export const numeric = (name: string) => `${name}は数値を入力してください`;
export const halfWidthPhoneNumber = (name: string) =>
  `${name}には半角数字またはハイフン(-)を入力してください`;
export const maxValue = (name: string, maxValue: number) =>
  `${name}は${maxValue}以下の数値で入力してください`;
